import { Dispatch, UnknownAction } from '@reduxjs/toolkit';
import { UserHeaderItemsType } from 'components/Headers/UserHeader/UserHeader';
import { userHeaderItems } from 'components/Headers/UserHeader/UserHeader';
import { sidebarItems, SidebarItemsType } from 'components/Sidebar/Sidebar';
import { setAdminItemSelected, setUserItemSelected } from 'features/menu';
import { Location } from 'react-router-dom';

export const locationListener = (location: Location<any>, dispatch: Dispatch<UnknownAction>) => {
    let pathName = location.pathname;

    if (pathName.endsWith('/')) {
        pathName = pathName.slice(0, -1);
    }

    if (pathName.includes('/app/admin')) {
        adminLocationListener(location, dispatch);
    } else {
        userLocationListener(location, dispatch);
    }
};

const adminLocationListener = (location: Location<any>, dispatch: Dispatch<UnknownAction>) => {
    const pathName = location.pathname;
    const itemSelected = sidebarItems.findIndex((item: SidebarItemsType) => item.url === pathName);

    if (itemSelected === -1) return;

    dispatch(setAdminItemSelected({ itemSelected }));
};

const userLocationListener = (location: Location<any>, dispatch: Dispatch<UnknownAction>) => {
    const pathName = location.pathname;
    const itemSelected = userHeaderItems.findIndex((item: UserHeaderItemsType) => item.url === pathName);

    if (itemSelected === -1) return;

    dispatch(setUserItemSelected({ itemSelected }));
};
